var _defs, _rect, _rect2, _rect3, _g, _rect4, _path, _path2, _g2, _g3, _path3, _path4, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPivot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 420.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .b {\r\n        fill: #3d57d3;\r\n      }\r\n\r\n      .b, .c, .d, .e, .f, .g, .h, .i {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .c {\r\n        fill: #1f3fd9;\r\n      }\r\n\r\n      .d {\r\n        fill: #c80a98;\r\n      }\r\n\r\n      .e {\r\n        fill: #cecece;\r\n      }\r\n\r\n      .f {\r\n        fill: #fff;\r\n      }\r\n\r\n      .g {\r\n        fill: #f000b4;\r\n      }\r\n\r\n      .h {\r\n        fill: #02db8c;\r\n      }\r\n\r\n      .i {\r\n        fill: #00ac6d;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 9.56,
    y: 9.56,
    width: 592.88,
    height: 401.62
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 9.56,
    y: 106.61,
    width: 296.44,
    height: 94.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 306,
    y: 202.23,
    width: 296.44,
    height: 94.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 306,
    y: 106.61,
    width: 296.44,
    height: 94.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 9.56,
    y: 200.81,
    width: 296.44,
    height: 103.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 306,
    y: 307.42,
    width: 296.44,
    height: 103.77
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 9.56,
    y: 315.57,
    width: 296.44,
    height: 94.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M38.11,76.55V9.62H9.6v95.44h592.47v-28.51H38.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M38.11,171.99v-66.93H9.6v95.44h296.23v-28.51H38.11Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M335.58,171.99v-66.93h-29.75v95.44h296.23v-28.51h-266.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.11,277.34v-66.93H9.6v95.44h296.23v-28.51H38.11Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M335.58,277.34v-66.93h-29.75v95.44h296.23v-28.51h-266.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M38.11,381.46v-65.69H9.6v95.44h296.23v-29.75H38.11Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M335.58,381.46v-65.69h-29.75v95.44h296.23v-29.75h-266.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0v420.75h612V0H0ZM592.88,19.12v77.25H19.13V19.12h573.75ZM295.92,210.41v86.76H19.13v-86.76h276.79ZM19.13,191.82v-76.85h276.79v76.85H19.13ZM314.51,210.41h278.37v86.76h-278.37v-86.76ZM314.51,191.82v-76.85h278.37v76.85h-278.37ZM19.13,315.76h276.79v85.86H19.13v-85.86ZM314.51,401.62v-85.86h278.37v85.86h-278.37Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 56.7,
    y: 48.04,
    width: 19.83,
    height: 18.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 95.12,
    y: 48.04,
    width: 18.59,
    height: 18.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 497.95,
    y: 48.04,
    width: 18.59,
    height: 18.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 536.37,
    y: 48.04,
    width: 18.59,
    height: 18.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 143.46,
    y: 48.04,
    width: 324.74,
    height: 18.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M582.23,391.37h-162.37v-18.59h143.78v-9.92h18.59v28.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 382.67,
    y: 372.78,
    width: 18.59,
    height: 18.59
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivot);
export default __webpack_public_path__ + "static/media/pivot.347401cfbd1780e3ca41a1dd7e861b37.svg";
export { ForwardRef as ReactComponent };